export const getOttRedirectUrl = (providerName, movieTitle) => {
  const title = encodeURIComponent(movieTitle);
  const name = providerName.toLowerCase();

  if (name.includes("netflix"))
    return `https://www.netflix.com/search?q=${title}`;

  if (name.includes("prime") || name.includes("amazon"))
    return `https://www.amazon.com/s?k=${title}&i=instant-video`;

  if (name.includes("disney"))
    return `https://www.disneyplus.com/search?q=${title}`;

  if (name.includes("hotstar"))
    return `https://www.hotstar.com/in/search?q=${title}`;

  if (name.includes("zee"))
    return `https://www.zee5.com/search?q=${title}`;

  if (name.includes("sony"))
    return `https://www.sonyliv.com/search/${title}`;

  return `https://www.google.com/search?q=${title}+watch+online`;
};
